import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/592c0ab5ce953f80d4c9292e1c104296.jpg"
          alt="Happy kids playing in colorful clothing"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/35 to-black/10"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
        <div className="max-w-2xl">
          <span
            className="inline-block bg-brand-purple/90 text-white text-xs font-600 px-4 py-2 rounded-full mb-6 uppercase tracking-widest"
            style={{ fontWeight: 600, fontFamily: "'Quicksand', sans-serif" }}
          >
            Kids Thrift Shop
          </span>

          <h1
            className="text-5xl md:text-6xl font-700 text-white leading-tight mb-6"
            style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}
          >
            Sustainable Style
            <br />
            <em className="not-italic text-brand-yellow">For Little Ones</em>
          </h1>

          <p className="text-white/85 text-lg leading-relaxed mb-8 max-w-lg">
            Second-hand clothing and used toys for kids ages <strong>1 to 12</strong>. First-rate quality at incredible prices — because caring for the planet is a kids' thing too.
          </p>

          <div className="flex flex-wrap gap-4">
            <Link
              to="/products"
              className="inline-flex items-center gap-2 bg-brand-yellow text-white px-7 py-3.5 rounded-full font-600 hover:bg-brand-yellow-dark transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontWeight: 600 }}
            >
              Explore Collection
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white border border-white/40 px-7 py-3.5 rounded-full font-600 hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontWeight: 600 }}
            >
              Our Story
            </Link>
          </div>

          <div className="flex flex-wrap gap-6 mt-10">
            {[
              { icon: 'ri-recycle-line', label: '100% Second-Hand' },
              { icon: 'ri-shield-check-line', label: 'Carefully Inspected' },
              { icon: 'ri-truck-line', label: 'Nationwide Shipping' },
            ].map(b => (
              <div key={b.label} className="flex items-center gap-2 text-white/80">
                <div className="flex items-center justify-center w-7 h-7">
                  <i className={`${b.icon} text-brand-green text-lg`}></i>
                </div>
                <span className="text-sm">{b.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
